var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90565 6.7885C1.54222 7.11114 1.00221 7.05828 0.698782 6.67184C0.395349 6.28541 0.445064 5.71031 0.808498 5.38858L5.09427 0.831563C5.13455 0.795107 5.18255 0.77779 5.22713 0.750448C5.26227 0.728574 5.29313 0.703055 5.3317 0.68665C5.43199 0.644725 5.53656 0.620117 5.64285 0.620117C5.74913 0.620117 5.85371 0.644725 5.95399 0.68665C5.99257 0.703055 6.02342 0.728574 6.05857 0.750448C6.10314 0.77779 6.15114 0.795107 6.19142 0.831563L10.4772 5.38858C10.8415 5.71031 10.8903 6.28541 10.5869 6.67184C10.2843 7.05828 9.74433 7.11114 9.38004 6.7885L6.5 3.47737L5.64292 2.56605L4.78377 3.47958L1.90565 6.7885Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.f8750827df19eefbf64ec665c6503fda.svg";
export { ForwardRef as ReactComponent };